import { useEffect, useRef } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useRealmAuthReset } from '@interxfi/api-client';
import { useLogout } from '@interxfi/api-client/userauth/logout';
import { FrameLoadingTrigger } from '@interxfi/design-system/components/frame/context';
import { Frame } from '@interxfi/design-system/components/frame/frame';
import { DEFAULT_UNAUTHENTICATED_ROUTE } from '../../util/routing/defaults';
import { getPageHead } from '../../util/routing/meta';

export const Route = createFileRoute('/_app/logout')({
  head: () => getPageHead('Sign Out'),
  component: Logout,
});

function Logout() {
  const isLoggingOutRef = useRef(false);
  const navigate = Route.useNavigate();
  const reset = useRealmAuthReset();
  const { mutateAsync } = useLogout();

  useEffect(() => {
    async function handleRedirect(): Promise<void> {
      try {
        try {
          await mutateAsync(undefined);
        } catch {}

        await navigate({ to: DEFAULT_UNAUTHENTICATED_ROUTE });
      } catch {
      } finally {
        reset(false);
      }
    }

    if (!isLoggingOutRef.current) {
      isLoggingOutRef.current = true;
      void handleRedirect();
    }
  }, [mutateAsync, navigate, reset]);

  return (
    <Frame fillY>
      <FrameLoadingTrigger />
    </Frame>
  );
}
